import React from 'react'

import ExternalLink from 'Components/ExternalLink'
import StoresMap from 'Components/Stores/StoresMap'

import cn from 'classnames'
import cg from 'Scss/app.scss'
import cl from './StoreAddress.scss'
import { SVGPhoneReceiver } from 'Components/SVGCollection';

type PropType = { store: Webshop.IStoreData }

const StoreAddress: React.SFC<PropType> = (props: PropType) => {
  const { store } = props
  return (
    <address className={cl.storeAddress}>
      <div className={cn(cg.gridX, cg.gridMarginX)}>
        <div className={cn(cg.cell, cg.medium5)}>
          <p className={cl.storeAddress__addressWrapper}>
            {store.address}
            <br />
            {store.details}
          </p>

          <h2 className={cl.h2}>Nyitvatartás</h2>

          {store.opening_hours.map((hour, id) => (
            <dl key={id} className={cn(cg.gridX, cg.gridPaddingX, cg.alignMiddle, cl.storeAddress__openingHours)}>
              <dt className={cn(cg.cell, cg.auto)}>
                {hour.label}
              </dt>

              <dd className={cn(cg.cell, cg.shrink)}>
                {hour.value}
              </dd>
            </dl>
          ))}

          <div className={cn(cg.gridX, cl.storeAddress__contactWrapper)}>
            <div className={cn(cg.cell, cg.auto, cg.medium12, cg.mediumOrder2)}>
              <ExternalLink href={`mailto:${store.email}`}>
                <span className={cn(cg.showForMedium, cl.linkLabel)}>
                  Email:
                </span>

                <span className={cl.underline}>
                  {store.email}
                </span>
              </ExternalLink>
            </div>

            <div className={cn(cg.cell, cg.auto, cg.medium12, cg.mediumOrder1)}>
              <ExternalLink href={`tel:${store.phone}`}>
                <span className={cn(cg.showForMedium, cl.linkLabel)} style={{display: 'inline-block', verticalAlign: 'middle'}}>
                  Telefon:
                </span>

                <span style={{display: 'inline-block', verticalAlign: 'middle'}}>
                  <SVGPhoneReceiver style={{display: 'inline-block', verticalAlign: 'middle'}} /> <span>{store.phone}</span>
                </span>
              </ExternalLink>
            </div>
          </div>
        </div>

        <div className={cn(cg.cell, cg.medium7)}>
          <StoresMap currentStore={store} />
        </div>
      </div>
    </address>
  )
}

export default StoreAddress
